<template>
<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-color-title`]" width="1em" height="1em" v-bind="$attrs"><rect x="1.92" y="3.498" width="20.162" height="17.004" rx="4" stroke="#165DFF" stroke-width="1.66" stroke-linejoin="round"/><path d="M12.2959 7.90161C12.7542 7.90168 13.126 8.27333 13.126 8.73169V15.2688C13.1258 15.727 12.7542 16.0988 12.2959 16.0989C11.8376 16.0989 11.466 15.7271 11.4658 15.2688V12.7278C11.4475 12.729 11.4288 12.7307 11.4102 12.7307H8.33398V15.2688C8.33385 15.7271 7.96222 16.0989 7.50391 16.0989C7.04559 16.0989 6.67396 15.7271 6.67383 15.2688V8.73169C6.67383 8.27329 7.04551 7.90161 7.50391 7.90161C7.9623 7.90161 8.33398 8.27329 8.33398 8.73169V11.0706H11.4102C11.4288 11.0706 11.4475 11.0713 11.4658 11.0725V8.73169C11.4658 8.27329 11.8375 7.90161 12.2959 7.90161ZM16.4971 11.1702C16.9554 11.1703 17.3271 11.5419 17.3271 12.0002V15.2688C17.3271 15.7271 16.9554 16.0987 16.4971 16.0989C16.0387 16.0989 15.667 15.7272 15.667 15.2688V12.0002C15.667 11.5418 16.0387 11.1702 16.4971 11.1702Z" :fill="useCurrentColor ? 'currentColor' : '#00BBD8'"/></svg>
</template>
<script>

export default {
  name: 'IconColorTitle',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
